import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TMediaKey = 'isMobile' | 'isTablet' | 'isDesktop' | 'isDesktopBig' | 'isDesktopSmall' | 'isDesktopMedium';

type TMediaQuery = Record<TMediaKey, boolean>;

type TState = TMediaQuery;

const initialState: TState = {
    isMobile       : false,
    isTablet       : false,
    isDesktop      : false,
    isDesktopSmall : false,
    isDesktopMedium: false,
    isDesktopBig   : false
};

export const getMediaQuery = createSlice({
    initialState,
    name    : 'media-query',
    reducers: {
        reset: () => initialState,
        set  : (state, action: PayloadAction<Partial<TState>>) => {
            return {
                ...state,
                ...action.payload
            };
        }
    }
});

export default getMediaQuery.reducer;
